import DataSourcesMeasures from './DataSourcesMeasures';

export default DataSourcesMeasures;
